// extracted by mini-css-extract-plugin
export default {"infoWrapper":"Info_infoWrapper__qUHkr","error":"Info_error__dLkO0","warn":"Info_warn__uF3+M"};